module.exports = __webpack_public_path__ + "static/ausopen-02-cce01ed37593d1d90edfbcc347193a94.png";